// Vivo companies-portal i18n messages (Arabic-first + English). Plain CommonJS
// so router/vivo-nav.js's keys can be unit-tested and i18n.ts can load it.
// Replaces the booking template's 2.5k-line i18nData.ts.
module.exports = {
  ar: {
    nav: {
      home: 'الرئيسية',
      employees: 'الموظفين',
      departments: 'الأقسام',
      adminFollowup: 'المتابعة الإدارية',
      claims: 'المطالبات',
      policyContract: 'البوليصة والعقد',
      providers: 'مقدمي الخدمة',
      reports: 'التقارير',
      companyData: 'بيانات الشركة',
      chatbotQa: 'أسئلة وأجوبة الشركة',
    },
    screens: {
      employeeAdd: 'إضافة موظف',
      employeeImport: 'رفع Excel',
      employeePage: 'صفحة الموظف',
      departmentAdd: 'إضافة قسم',
      departmentEdit: 'تعديل قسم',
      claimAdd: 'تسجيل مطالبة',
      departments: 'الأقسام',
      adminFollowup: 'المتابعة الإدارية',
      providers: 'مقدّمو الخدمة',
      chatbotQa: 'أسئلة وأجوبة الشركة',
    },
    common: {
      comingSoon: 'قريبًا',
      comingSoonDesc: 'ستتوفر هذه الشاشة في المرحلة القادمة (Phase 5)',
      company: 'فيفو مصر',
      search: 'ابحث باسم موظف أو رقم قومي أو رقم بوليصة...',
      login: 'دخول الشركة',
      logout: 'تسجيل الخروج',
      portalTitle: 'فيفو · بوابة الشركات',
      account: 'الحساب',
      noRecords: 'لا توجد بيانات',
      portalSub: 'بوابة الشركات',
      previous: 'السابق',
      next: 'التالي',
      roleHr: 'مسؤول الموارد البشرية',
      menu: 'القائمة',
    },
    mobileMenu: {
      search: 'ابحث',
      account: 'الحساب',
    },
    footer: {
      copyright: '© {year} فيفو. جميع الحقوق محفوظة.',
    },
    login: {
      title: 'دخول الشركة',
      companyCodeOrEmail: 'كود الشركة أو البريد',
      password: 'كلمة السر',
      submit: 'دخول',
      cancel: 'إلغاء',
      errorTitle: 'خطأ',
      welcome: 'أهلاً بيك',
      subtitle: 'سجّل دخولك لإدارة موظفي شركتك ومطالباتهم.',
      email: 'البريد الإلكتروني',
      emailPlaceholder: 'name@company.com',
      passwordPlaceholder: 'اكتب كلمة السر',
      showPassword: 'إظهار كلمة السر',
      hidePassword: 'إخفاء كلمة السر',
      signingIn: 'جارٍ الدخول…',
      invalid: 'البريد أو كلمة السر غير صحيحين.',
      brandTitle: 'التأمين الطبي لموظفيك، في مكان واحد',
      brandText: 'تابع الموظفين والمطالبات والبوليصة بسهولة ووضوح.',
      feature1: 'إضافة الموظفين فردي أو برفع ملف Excel',
      feature2: 'متابعة حالة كل مطالبة لحظة بلحظة',
      feature3: 'بوليصتك وشبكة مقدمي الخدمة قدامك',
      noDashboardAccess: 'لا تملك صلاحية الدخول إلى لوحة التحكم',
    },
    home: {
      title: 'لوحة مؤشرات الشركة',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل البيانات',
      period: { d30: 'آخر 30 يوم', quarter: 'الربع الحالي', year: 'السنة الحالية' },
      kpi: {
        insured: 'موظف مؤمَّن عليه',
        active: 'نشط',
        suspendedLeft: 'موقوف / مغادر',
        openClaims: 'مطالبة مفتوحة',
      },
      charts: {
        monthlyTitle: 'الموظفين المضافين شهريًا',
        monthlyLegend: 'موظفون تمت إضافتهم',
        donutTitle: 'توزيع الموظفين حسب الحالة',
        employeeUnit: 'موظف',
      },
      status: { active: 'نشط', suspended: 'موقوف', left: 'مغادر' },
      claimStatus: {
        registered: 'اتسجّلت',
        at_insurer: 'عند التأمين',
        missing_doc: 'ناقصها مستند',
        accepted: 'اتقبلت',
        rejected: 'اترفضت',
      },
      policy: {
        title: 'حالة البوليصة والعقد',
        statuses: { active: 'سارية', suspended: 'موقوفة', expired: 'منتهية', cancelled: 'ملغية' },
        statusUnknown: 'حالة غير معروفة',
        active: 'سارية',
        number: 'رقم البوليصة',
        validity: 'سريان البوليصة',
        contract: 'العقد الموقّع',
        insurer: 'شركة التأمين',
      },
      actions: {
        title: 'إجراءات سريعة',
        newEmployee: 'موظف جديد',
        uploadExcel: 'رفع Excel',
        recentTitle: 'آخر النشاطات',
        recentEmpty: 'لسه مفيش مطالبات. سجّل مطالبة من شاشة المطالبات وهتظهر هنا.',
      },
    },
  },
  en: {
    nav: {
      home: 'Home',
      employees: 'Employees',
      departments: 'Departments',
      adminFollowup: 'Admin Follow-up',
      claims: 'Claims',
      policyContract: 'Policy & Contract',
      providers: 'Providers',
      reports: 'Reports',
      companyData: 'Company Data',
      chatbotQa: 'Company Q&A',
    },
    screens: {
      employeeAdd: 'Add Employee',
      employeeImport: 'Import Excel',
      employeePage: 'Employee Page',
      departmentAdd: 'Add department',
      departmentEdit: 'Edit department',
      claimAdd: 'Register a claim',
      departments: 'Departments',
      adminFollowup: 'Admin Follow-up',
      providers: 'Providers',
      chatbotQa: 'Company Q&A',
    },
    common: {
      comingSoon: 'Coming soon',
      comingSoonDesc: 'This screen arrives in the next phase (Phase 5)',
      company: 'Vivo Egypt',
      search: 'Search by employee name, national ID or policy no...',
      login: 'Company Login',
      logout: 'Logout',
      portalTitle: 'Vivo · Companies Portal',
      account: 'Account',
      noRecords: 'No records found',
      portalSub: 'Companies Portal',
      previous: 'Previous',
      next: 'Next',
      roleHr: 'HR Manager',
      menu: 'Menu',
    },
    mobileMenu: {
      search: 'Search',
      account: 'Account',
    },
    footer: {
      copyright: '© {year} Vivo. All rights reserved.',
    },
    login: {
      title: 'Company Login',
      companyCodeOrEmail: 'Company code or email',
      password: 'Password',
      submit: 'Sign in',
      cancel: 'Cancel',
      errorTitle: 'Error',
      welcome: 'Welcome back',
      subtitle: 'Sign in to manage your employees and their claims.',
      email: 'Email',
      emailPlaceholder: 'name@company.com',
      passwordPlaceholder: 'Enter your password',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      signingIn: 'Signing in…',
      invalid: 'Incorrect email or password.',
      brandTitle: 'Your employees’ medical insurance, in one place',
      brandText: 'Track employees, claims and your policy with clarity.',
      feature1: 'Add employees one by one or upload an Excel file',
      feature2: 'Follow every claim’s status in real time',
      feature3: 'Your policy and provider network at a glance',
      noDashboardAccess: 'You do not have permission to access the dashboard',
    },
    home: {
      title: 'Company Dashboard',
      loading: 'Loading…',
      error: 'Something went wrong while loading data',
      period: { d30: 'Last 30 days', quarter: 'This quarter', year: 'This year' },
      kpi: {
        insured: 'Insured employees',
        active: 'Active',
        suspendedLeft: 'Suspended / left',
        openClaims: 'Open claims',
      },
      charts: {
        monthlyTitle: 'Employees added monthly',
        monthlyLegend: 'Employees added',
        donutTitle: 'Employees by status',
        employeeUnit: 'employees',
      },
      status: { active: 'Active', suspended: 'Suspended', left: 'Left' },
      claimStatus: {
        registered: 'Registered',
        at_insurer: 'At insurer',
        missing_doc: 'Missing document',
        accepted: 'Accepted',
        rejected: 'Rejected',
      },
      policy: {
        title: 'Policy & contract status',
        statuses: { active: 'Active', suspended: 'Suspended', expired: 'Expired', cancelled: 'Cancelled' },
        statusUnknown: 'Unknown status',
        active: 'Active',
        number: 'Policy no.',
        validity: 'Policy validity',
        contract: 'Signed contract',
        insurer: 'Insurer',
      },
      actions: {
        title: 'Quick actions',
        newEmployee: 'New employee',
        uploadExcel: 'Import Excel',
        recentTitle: 'Recent activity',
        recentEmpty: 'No claims yet. Register one from the Claims screen and it will appear here.',
      },
    },
  },
};
